"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTextByKey = void 0;
var react_1 = require("react");
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var useGetTextByKey = function (isLoading, text) {
    return (0, react_1.useCallback)(function (key, variables) {
        var _a;
        if (isLoading)
            return '';
        var preparedKey = key.toUpperCase();
        var result = ((_a = (text || {})) === null || _a === void 0 ? void 0 : _a[preparedKey]) || preparedKey;
        if (variables) {
            result = result.replace(/\{\{(\w+)\}\}/g, function (_, variableName) {
                return variables[variableName] !== undefined
                    ? variables[variableName]
                    : "{{".concat(variableName, "}}");
            });
        }
        return (0, react_html_parser_1.default)(result.replace(/\n/g, '<br/>'));
    }, [text, isLoading]);
};
exports.useGetTextByKey = useGetTextByKey;
